import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'projects/coguasimales/src/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GestionUsuarioService {
  _baseURL: string = environment.base;
  constructor(private http: HttpClient) {}

  getToken() {
    return localStorage.getItem('token');
  }

  setToken(token) {
    localStorage.setItem('token', token);
  }

  getListUser(params, idAgencia): Observable<any> {
    const url = `${this._baseURL}/coguasimales/agencies/${idAgencia}/users`;

    return this.http
      .get(url, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: '*/*',
          Authorization: this.getToken(),
        }),
        params,
      })
      .pipe(map((data) => data));
  }

  getListSex(): Observable<any> {
    const url = `${this._baseURL}/register/genders`;

    return this.http
      .get(url, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: '*/*',
        }),
      })
      .pipe(map((data) => data));
  }

  getListRoles(): Observable<any> {
    const url = `${this._baseURL}/coguasimales/agency-roles`;

    return this.http
      .get(url, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: '*/*',
          Authorization: this.getToken(),
        }),
      })
      .pipe(map((data) => data));
  }

  detailsUser(idAgencia, idUser): Observable<any> {
    const url = `${this._baseURL}/coguasimales/agencies/${idAgencia}/users/${idUser}`;

    return this.http
      .get(url, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: '*/*',
          Authorization: this.getToken(),
        }),
      })
      .pipe(map((data) => data));
  }

  blockUser(idAgencia, idUser): Observable<any> {
    const url = `${this._baseURL}/coguasimales/agencies/${idAgencia}/users/${idUser}/block`;

    return this.http
      .post(
        url,
        {},
        {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            Accept: '*/*',
            Authorization: this.getToken(),
          }),
        }
      )
      .pipe(map((data) => data));
  }

  infoActiveUser(idAgencia, idUser): Observable<any> {
    const url = `${this._baseURL}/coguasimales/agencies/${idAgencia}/users/${idUser}/active`;

    return this.http
      .get(url, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: '*/*',
          Authorization: this.getToken(),
        }),
      })
      .pipe(map((data) => data));
  }

  activeUser(idAgencia, idUser): Observable<any> {
    const url = `${this._baseURL}/coguasimales/agencies/${idAgencia}/users/${idUser}/active`;

    return this.http
      .post(
        url,
        {},
        {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            Accept: '*/*',
            Authorization: this.getToken(),
          }),
        }
      )
      .pipe(map((data) => data));
  }

  editUser(idAgencia, idUser, body): Observable<any> {
    const url = `${this._baseURL}/coguasimales/agencies/${idAgencia}/users/${idUser}/edit`;

    return this.http
      .post(url, body, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: '*/*',
          Authorization: this.getToken(),
        }),
      })
      .pipe(map((data) => data));
  }

  addUser(body, idAgencia): Observable<any> {
    const url = `${this._baseURL}/coguasimales/agencies/${idAgencia}/users/new
    `;

    return this.http
      .post(url, body, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: '*/*',
          Authorization: this.getToken(),
        }),
      })
      .pipe(map((data) => data));
  }

  changePassword(body, idUser, idAgencia): Observable<any> {
    const url = `${this._baseURL}/coguasimales/agencies/${idAgencia}/users/${idUser}/reset-pass`;

    return this.http
      .post(url, body, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          Accept: '*/*',
          Authorization: this.getToken(),
        }),
      })
      .pipe(map((data) => data));
  }
}
